import React, { FC, memo, useState } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { NOTIFICATION_DEFAULT_ERROR_MESSAGE, useNotificationContext } from 'application/providers/NotificationProvider';

import { usePointsGroupUpdateMutation } from '@shared/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import Input, { InputType } from '@zvuk-b2b/react-uikit/ui/Input';

import { TEXTS } from './texts';

import styles from './index.module.scss';

const MAX_TITLE_LENGTH = 128;

export const RenamePointsGroupModal: FC<ModalProps[ModalTypes.RENAME_POINTS_GROUP]> = memo(
  ({ devicesGroupId, title: initialTitle, close }) => {
    const notification = useNotificationContext();

    const [mutate, mutationResult] = usePointsGroupUpdateMutation();

    const [title, setTitle] = useState<string>(initialTitle || '');

    const onSave = async () => {
      if (devicesGroupId) {
        try {
          const ok = await mutate({ variables: { input: { devicesGroupId, title } } });

          if (ok) {
            close();

            notification.showInfoNotification({
              children: TEXTS.NOTIFICATION_SUCCESS_TEXT,
            });
          } else {
            notification.showErrorNotification({
              children: NOTIFICATION_DEFAULT_ERROR_MESSAGE,
            });
          }
        } catch (e: unknown) {
          const error = e as Error;

          if (/value too long/.test(error.message)) {
            notification.showErrorNotification({ children: TEXTS.NOTIFICATION_ERROR_TOO_LONG_TEXT });
          }
        }
      }
    };

    return (
      <ModalScreen
        title={TEXTS.TITLE}
        titlePlacement="left"
        onClose={close}
        className={styles.description}
        actionButtons={[
          <Button
            key="button_rename_points_group_modal"
            elementId="button_rename_points_group_modal"
            type={ButtonType.PRIMARY}
            isLoading={mutationResult.loading}
            isDisabled={title === initialTitle}
            onClick={onSave}>
            {TEXTS.SAVE_BUTTON_TEXT}
          </Button>,
        ]}>
        <Input
          elementId="button_rename_points_group_input"
          type={InputType.TEXT}
          containerClassName={styles.input}
          value={title}
          maxLength={MAX_TITLE_LENGTH}
          isDisabled={mutationResult.loading}
          placeholder={TEXTS.INPUT_PLACEHOLDER}
          onChange={setTitle}
        />
      </ModalScreen>
    );
  }
);
